import { isMobile, showPanel, hideAllPanels } from '../utils/overlay';

document.addEventListener('DOMContentLoaded', function() {
    const block = document.querySelector('.investment-process');
    if (!block) return;

    const stepButtons = block.querySelectorAll('.investment-process__step');
    const panels = block.querySelectorAll('.investment-process__panel');
    const progressFill = block.querySelector('.investment-process__progress-bar__fill');
    const closeButtons = block.querySelectorAll('.investment-process__panel__close');
    const backdrop = block.querySelector('.investment-process__backdrop');
    const totalSteps = stepButtons.length;

    function setProgressBar(index) {
        if (!progressFill || totalSteps <= 1) return;
        progressFill.style.height = ((index + 1) / totalSteps) * 100 + '%';
    }

    function deactivateSteps() {
        stepButtons.forEach(btn => {
            btn.classList.remove('is-active');
            btn.setAttribute('aria-expanded', 'false');
        });
        panels.forEach(panel => panel.setAttribute('aria-hidden', 'true'));
    }

    function activateStep(index) {
        hideAllPanels(panels, backdrop);
        deactivateSteps();

        const btn = stepButtons[index];
        const panel = panels[index];

        if (btn) {
            btn.classList.add('is-active');
            btn.setAttribute('aria-expanded', 'true');
        }

        if (panel) panel.setAttribute('aria-hidden', 'false');
        showPanel(panel, backdrop);
        setProgressBar(index);
    }

    stepButtons.forEach(btn => {
        btn.addEventListener('click', function() {
            activateStep(+this.dataset.stepIndex);
        });
    });

    closeButtons.forEach(btn => {
        btn.addEventListener('click', function(e) {
            e.stopPropagation();
            if (!isMobile()) {
                activateStep(0);
            } else {
                hideAllPanels(panels, backdrop);
                deactivateSteps();
            }
        });
    });

    if (backdrop) {
        backdrop.addEventListener('click', function() {
            hideAllPanels(panels, backdrop);
            deactivateSteps();
        });
    }

    if (totalSteps > 0) {
        if (isMobile()) {
            hideAllPanels(panels, backdrop);
            deactivateSteps();
        } else {
            activateStep(0);
        }
    }

    let wasMobile = isMobile();
    let resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            const nowMobile = isMobile();
            if (wasMobile && !nowMobile) {
                const hasActive = block.querySelector('.investment-process__step.is-active');
                if (!hasActive) activateStep(0);
            }
            wasMobile = nowMobile;
        }, 100);
    });
});
